export const SearchFormWrapper = ({children}) => {
  return <div style={{width:200, height: 38}}>{children}</div>
}
